/* eslint-disable vue/multi-word-component-names */
import { createApp, h } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'

import PrimeVue from 'primevue/config'
import 'primevue/resources/primevue.min.css'
import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'

// don't import the theme as it sets font and colors
// instead copy and adapt the parts for the imported component
// into public/assets/sass/layout/_primevue.scss
//import "primevue/resources/themes/saga-blue/theme.css";
import '@/assets/gen/fantasticon/custom-icons.css'
import '../public/assets/layout/css/layout.scss'

import AppSubMenuLink from './components/AppSubMenuLink.vue'
import AppMenuLink from './components/AppMenuLink.vue'
import Button from './components/Button.vue'
import Tag from './components/Tag.vue'
import CategoryCard from './components/CategoryCard.vue'
import InputBlock from '@/components/InputBlock.vue'
import InputSectionTag from '@/components/InputSectionTag.vue'

import OverlayPanel from 'primevue/overlaypanel'
import ScrollPanel from 'primevue/scrollpanel'
import DataView from 'primevue/dataview'
import DataTable from 'primevue/datatable'
import Toast from 'primevue/toast'
import ToastService from 'primevue/toastservice'
import Dialog from 'primevue/dialog'
import FileUpload from 'primevue/fileupload'
import Column from 'primevue/column'
import Dropdown from 'primevue/dropdown'
import InputText from 'primevue/inputtext'
import Checkbox from 'primevue/checkbox'
import ProgressSpinner from 'primevue/progressspinner'
import Badge from 'primevue/badge'

import { initOidc } from '@/composables/auth'

const app = createApp({
  render() {
    return h(App)
  }
})

app.component('AppSubMenuLink', AppSubMenuLink)
app.component('AppMenuLink', AppMenuLink)
app.component('OverlayPanel', OverlayPanel)
app.component('ScrollPanel', ScrollPanel)
app.component('DataView', DataView)
app.component('DataTable', DataTable)
app.component('Dialog', Dialog)
app.component('FileUpload', FileUpload)
app.component('Column', Column)
app.component('Dropdown', Dropdown)
app.component('InputText', InputText)
app.component('Checkbox', Checkbox)
app.component('ProgressSpinner', ProgressSpinner)
app.component('Badge', Badge)

app.component('app-button', Button)
app.component('toast', Toast)
app.component('InputBlock', InputBlock)
app.component('InputSectionTag', InputSectionTag)

app.component('app-tag', Tag)
app.component('CategoryCard', CategoryCard)
app.use(i18n)
app.use(router)
app.use(PrimeVue)
app.use(ToastService)

initOidc().then(() => app.mount('#app'))
